<template>
	<div
		id="patient-modal"
		class="modal fade"
		data-backdrop="static"
		aria-labelledby="patient-modal"
		@keyup.esc.stop.prevent="CloseModal()"
	>
		<div class="modal-dialog">
			<div class="modal-content">
				<GridLayout
					:reactive-sidebar="false"
					:sidebar-state="false"
				>
					<template #right-header>
						<div
							class="w-full h-full flex items-center gap-3 position-relative"
						>
							<button
								class="btn btn-rounded"
								@click="CloseModal()"
							>
								<i class="fas fa-chevron-left"></i>
							</button>
							<Title value="CADASTRAR PACIENTE" />
							<div class="close-container">
								<button
									type="button"
									class="btn btn-tool"
									data-dismiss="modal"
									@click="CloseModal()"
								>
									<i class="far fa-times mx-1 font-24"></i>
								</button>
							</div>
						</div>
					</template>
					<template #right-content>
						<div
							ref="modalBody"
							class="modal-body main-content w-full"
						>
							<div
								class="w-full h-full flex flex-col items-center main-content"
							>
								<PatientIdentification
									:patient="patient"
									@on-update-avatar="UpdateAvatar"
								/>

								<PatientForm
									ref="patient_form"
									:patient="patient"
									class="px-4"
									@next="patient = $event.patient"
								/>
							</div>
						</div>
					</template>
					<template #right-footer>
						<div
							class="w-full h-full flex justify-start items-center"
						>
							<button
								type="button"
								class="btn btn-danger btn-fixed-size"
								@click="CloseModal()"
							>
								CANCELAR
							</button>
						</div>
						<div
							class="w-full h-full flex justify-center items-center"
						>
							<button
								type="button"
								class="btn btn-fixed-size"
								@click="$refs.patient_form.ClearForm()"
							>
								LIMPAR
							</button>
						</div>
						<div
							class="w-full h-full flex justify-end items-center"
						>
							<button
								type="button"
								class="btn btn-success btn-fixed-size"
								@click="$refs.patient_form.Continue()"
							>
								SALVAR
							</button>
						</div>
					</template>
				</GridLayout>
			</div>
		</div>
	</div>
</template>

<script>
	import modalMixin from '@/mixins/modal'

	export default {
		name: 'PatientModal',
		mixins: [modalMixin],
		components: {},
		data() {
			return {
				modalId: '#patient-modal',
				patient: {},
			}
		},
		methods: {
			Previous() {
				this.CloseModal()
			},
			UpdateAvatar(avatar) {
				this.$set(this.patient, 'avatar', avatar)
			},
		},
		mounted() {
			this.OpenModal()
		},
	}
</script>

<style lang="scss" scoped>
	#patient-modal {
		.modal-dialog {
			max-width: 100vw;
			max-height: 100vh;
			margin: 0;

			.modal-content {
				height: 100vh;
				display: flex;
				flex-direction: column;
				align-items: center;

				.grid-layout {
					height: 100vh;

					.main-content {
						max-height: calc(
							100vh - 2.775rem - var(--secondaryQuadrantHeight) *
								2
						);
					}
				}
			}
		}
	}
</style>
